import D1 from '../../components/ExcerciseTypes/Design/TypeIn';




const json = {
    1: { // Exercise num
        unit: 'Review 2',
        id: 'WB4-V2-PV2-P46-E1',
        audio: '',
        video: '',
        component: D1,
        padding: 0,
        exerciseKey: 'img/FriendsPlus/Page46/E1/Key/answerKey.png',
        textAlign: 'center',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page46/E1/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page46/E1/2.jpg' },
                { url: 'img/FriendsPlus/Page46/E1/3.jpg', input: true, answer: "their" },
                { url: 'img/FriendsPlus/Page46/E1/4.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page46/E1/5.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page46/E1/6.jpg' },
                { url: 'img/FriendsPlus/Page46/E1/7.jpg', input: true, answer: "my" },
                { url: 'img/FriendsPlus/Page46/E1/8.jpg' },
                { url: 'img/FriendsPlus/Page46/E1/9.jpg', input: true, answer: "your" },
                { url: 'img/FriendsPlus/Page46/E1/10.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page46/E1/11.jpg' },
            ],
        ],
    },

    2: { // Exercise num
        unit: 'Review 2',
        id: 'WB4-V2-PV2-P46-E2',
        audio: '',
        video: '',
        component: D1,
        checkDuplicated: true,
        exerciseKey: 'img/FriendsPlus/Page46/E2/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page46/E2/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page46/E2/2.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/3.jpg', input: true, answer: "morning/afternoon/evening" },
                { url: 'img/FriendsPlus/Page46/E2/4.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/5.jpg', input: true, answer: "balloons/nuts/candy/tie" },
                { url: 'img/FriendsPlus/Page46/E2/6.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page46/E2/7.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/8.jpg', input: true, answer: "math/music/English" },
                { url: 'img/FriendsPlus/Page46/E2/9.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/10.jpg', input: true, answer: "morning/afternoon/evening" },
                { url: 'img/FriendsPlus/Page46/E2/11.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/12.jpg', input: true, answer: "balloons/nuts/candy/tie" },
                { url: 'img/FriendsPlus/Page46/E2/13.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page46/E2/14.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/15.jpg', input: true, answer: "math/music/English" },
                { url: 'img/FriendsPlus/Page46/E2/16.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/17.jpg', input: true, answer: "morning/afternoon/evening" },
                { url: 'img/FriendsPlus/Page46/E2/18.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/19.jpg', input: true, answer: "balloons/nuts/candy/tie" },
                { url: 'img/FriendsPlus/Page46/E2/20.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page46/E2/21.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/22.jpg', input: true, answer: "math/music/English" },
                { url: 'img/FriendsPlus/Page46/E2/23.jpg' },
                { url: 'img/FriendsPlus/Page46/E2/24.jpg', input: true, answer: "alloons/nuts/candy/tie" },
                { url: 'img/FriendsPlus/Page46/E2/25.jpg' },
            ],
            [
                // Column6
                { url: 'img/FriendsPlus/Page46/E2/26.jpg' },
            ],

        ],
    },

    3: { // Exercise num
        unit: 'Unit 6',
        id: 'WB1-U6-P46-E3',
        audio: '',
        video: '',
        component: D1,
        typeInput: 'center',
        fontSize: 40,
        inputHeight: 42,
        isAllowSubmit: false,
        exerciseKey: 'img/FriendsPlus/Page46/E3/Key/answerKey.png',
        questionImage: [ // Row
            [
                // Column1
                { url: 'img/FriendsPlus/Page46/E3/1.jpg' },
            ],
            [
                // Column2
                { url: 'img/FriendsPlus/Page46/E3/2.jpg' },
                { url: 'img/FriendsPlus/Page46/E3/3.jpg', input: true, answer: "d" },
                { url: 'img/FriendsPlus/Page46/E3/4.jpg' },
                { url: 'img/FriendsPlus/Page46/E3/5.jpg', input: true, answer: "f" },
                { url: 'img/FriendsPlus/Page46/E3/6.jpg' },
            ],
            [
                // Column3
                { url: 'img/FriendsPlus/Page46/E3/7.jpg' },
            ],
            [
                // Column4
                { url: 'img/FriendsPlus/Page46/E3/8.jpg' },
                { url: 'img/FriendsPlus/Page46/E3/9.jpg', input: true, answer: "g" },
                { url: 'img/FriendsPlus/Page46/E3/10.jpg' },
                { url: 'img/FriendsPlus/Page46/E3/11.jpg', input: true, answer: "a" },
                { url: 'img/FriendsPlus/Page46/E3/12.jpg' },
            ],
            [
                // Column5
                { url: 'img/FriendsPlus/Page46/E3/13.jpg' },
            ],

        ],
    },
}

export default json;